module.exports = __webpack_public_path__ + "img/ios-bg-zh.eeee2a44.png";